import { Injectable } from "@angular/core";
import { Vinculo } from "@tivic-team/manager-ts/dist/grl/entities/vinculo.entity";
import { VinculoController } from "app/controllers/grl/vinculo.controller";
import { LoaderService } from "../loader.service";
import { VinculoSearch } from "./vinculo.search";

@Injectable()
export class VinculoService {

    constructor(
        private _vinculoController: VinculoController,
        private _loaderService: LoaderService
    ) {}

    async find( tipoVinculoSearch: VinculoSearch ):Promise< Vinculo[] > {
        this._loaderService.show();
        try {
            return await this._vinculoController.find( ( tipoVinculoSearch && tipoVinculoSearch.getFilters() ) || null ).finally( () => this._loaderService.hide() );
            
        } catch( error ) {
            this._loaderService.hide();
            return [];
        }
    }

    async save( vinculo: Vinculo ):Promise< Vinculo > {
        this._loaderService.show();
        if( vinculo.cdVinculo && vinculo.cdVinculo > 0 ) {

            return this._vinculoController.update( vinculo ).finally( () => this._loaderService.hide() );
        } else {
            return this._vinculoController.create( vinculo ).finally( () => this._loaderService.hide() );
        }
    }

    async get( cdVinculo:number ):Promise< Vinculo > {
        this._loaderService.show();

        return this._vinculoController.get( cdVinculo ).finally( () => this._loaderService.hide() );
    }

}
